import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

export default function LatestUpdates() {
  const latest = [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">第一时间追更热门韩漫</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap font-medium"
          >
            更多更新
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {latest.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}